import { PARTNERS_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'

import query from '../graphql/partner.graphql'
import { GetPartnerQuery, GetPartnerQueryVariables } from '../interfaces'

export const getPartner = async (variables: GetPartnerQueryVariables): Promise<GetPartnerQuery> =>
  request<GetPartnerQuery, GetPartnerQueryVariables>(PARTNERS_ENDPOINT, query, variables)
